<template>
    <a
        class="imgcard"
        :href="type=='submission'?`/Submission/Index?Id=${data.Id}`:`/Submission/Admission?Id=${data.Id}`"
    >
        <div class="img">
            <img :src="data.Image" :alt="data.Title" />
        </div>
        <div class="title">{{data.Title}}</div>
        <div class="date" v-if="domain != 'Admission'">
            <div class="icon icon-pen"></div>
            <span>投稿時間:{{data.StartOn.split("T")[0] + " ~ " + data.EndOn.split("T")[0]}}</span>
        </div>
    </a>
</template>

<script>
export default {
    name: "imgcard",
    components: {},
    props: {
        data: {
            type: Object
        },
        type: {
            type: String
        }
    },
    data() {
        return {
            domain: location.pathname.split("/")[2]
        };
    },
    methods: {},
    computed: {},
    created() {},
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.imgcard {
    border: 1px solid #eee;
    padding: 20px 15px;
    margin-bottom: 30px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    width: 100%;
    color: #666;
    text-decoration: none;
    letter-spacing: 2px;
    line-height: 1.5;
    height: 100%;
}
.imgcard .img {
    width: 100%;
    margin: auto;
    font-size: 0;
    margin-bottom: 10px;
    /* flex: 1; */
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: auto;
}
.imgcard .img img {
    width: 100%;
}
.imgcard .title {
    padding: 8px 0;
    min-height: 60px;
    text-align: center;
    vertical-align: middle;
}
.imgcard .date {
    text-align: center;
    padding: 8px 0 16px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 0.9rem;
    justify-content: center;
}
.imgcard .date > div {
    padding-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/submission/imgCard.vue